import styles from "./AvatarNavBar.module.scss";
import { MdNotificationsActive, MdNotifications } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
export default function AvatarNavbar({
  dashboard,
  notification,
  setNotification,
  unseen,
}) {
  const location = useLocation();

  const firstname = "Jan";

  const lastname = "Kowalski";

  const role = "Administrator";

  const navigate = useNavigate();

  const goToView = () => {
    navigate(`/operators/view/1`);
  };

  return (
    <div
      className={
        location.pathname === "/"
          ? `${styles.wrapper}`
          : `${styles.wrapper} ${styles.transBg}`
      }
    >
      <div className={styles.info} onClick={goToView}>
        <span className={styles.name}>
          {firstname !== null ? firstname : ""}{" "}
          {lastname !== null ? lastname : ""}
        </span>
        <span className={styles.desc}>{role !== null ? role : ""}</span>
      </div>
      <div className={styles.avatar} onClick={goToView}>
        {firstname !== null ? firstname.charAt(0) : ""}
        {lastname !== null ? lastname.charAt(0) : ""}
      </div>
      <IconButton>
        {unseen ? (
          <MdNotificationsActive style={{ color: "#e40521" }} />
        ) : (
          <MdNotifications style={{ color: "gray" }} />
        )}

        {unseen ? <span className={styles.unseen}></span> : ""}
      </IconButton>
    </div>
  );
}
